/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILosInterface } from '@app/models/los-interface.model';
import { Observable, of, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { Constants } from 'src/app/constants';

@Injectable({
  providedIn: 'root'
})
export class LosInterfaceService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Gets status
   * @param { AccountId }
   * @returns status
   */
  loanStatus$: Observable<any>;

  public getLoanStatus({ AccountId }): Observable<ILosInterface> {
    const losId = JSON.parse(sessionStorage.getItem('hubData')).LosId;
    let headers = new HttpHeaders();
    headers = headers.append('error-whitelist', 'true');
    this.loanStatus$ ||= this.http.get<ILosInterface>(
      `${Constants.appConfiguration.apiRoot}/LosInterface/${AccountId}/${losId}`,
      { headers }
    );
    return this.loanStatus$.pipe(
      catchError(err => {
        if (err.includes('404')) {
          return of({});
        }
        throwError(err);
      }),
      shareReplay({ refCount: true })
    );
  }
}
